import { InstanceOperationsName } from '@frontend/types';

type RAGToolRequirement = {
  instanceCapabilities?: InstanceOperationsName[];
  disabledMessage: string;
};

const RAG_DISABLED_MESSAGE =
  'This tool requires RAG (Retrieval-Augmented Generation) to be enabled for your organization. Please contact your admin to enable RAG.';

/**
 * Maps RAG tool names to their required flags/capabilities.
 * Tools must have ALL listed requirements enabled (AND logic).
 */
export const RAG_TOOL_REQUIREMENTS: Record<string, RAGToolRequirement> = {
  retrieve_from_cmp: {
    instanceCapabilities: ['RAG_enabled'],
    disabledMessage: RAG_DISABLED_MESSAGE,
  },
  retrieve_from_cmp_as_csv: {
    instanceCapabilities: ['RAG_enabled'],
    disabledMessage: RAG_DISABLED_MESSAGE,
  },
};
